<template>
	<div class="memberCenter layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				<i @click="setClass(1)" v-if="showClass!=1" class="layui-icon-left layui-icon px20 pointer" style="margin-right:20px;"></i> {{showClass==1?'会员中心':'积分明细'}}
			</div>
		</div>
		<!-- 会员中心模块 -->
		<div v-show="showClass==1">
			<div style="padding: 20px;" class="border_b px16">
				<div class="f_row al_itm" style="margin-bottom:20px;">
					<span>{{userInfo.corporate_name ? userInfo.corporate_name : '昵称'}}</span>
					<span style="margin-left:30px;">ID:{{userInfo.id}}</span>
					<span @click="setClass(2)" class="pointer" style="margin-left:30px;color:rgb(255, 152, 0);">积分: {{userInfo.score ? userInfo.score : 0}}</span>
				</div>
				<div class="f_row al_itm" style="margin-bottom:10px;">
					<span>{{userInfo.online_status == 1 ? '在线':'离线'}}</span>	
					<div class="layui-form margin_l20">
						<input type="checkbox" name="switch" lay-skin="switch" id="switch">
					</div>
					<span class="margin_l20 px14" style="color:#707070;">{{userInfo.online_status == 1 ? '在线状态可进行接单或系统派单':'离线状态不可进行接单或系统派单'}}</span>
				</div>
			</div>
			<div class="f_row al_itm jc_sb" style="padding: 30px 0;border-bottom:1px solid #bbb;font-family:SourceHanSansSC;">
				<div class="f_col al_itm" style="width:50%;">
					<span class="px24 color_4a">当月接单量</span>
					<span class="px24" style="padding:30px 0;">{{orderInfo.total}}</span>
					<span class="px16 color_q">距目标还差 {{orderInfo.task}}</span>
				</div>
				<div class="f_col al_itm" style="width:50%;">
					<span class="px24 color_4a">当月完成订单</span>
					<span class="px24" style="padding:30px 0;">{{orderInfo.month}}</span>
					<div class="f_row al_itm px16">
						<span class="zt_txt_color">准时交付{{orderInfo.ontime}}%</span>
						<span class="mon_color" style="margin-left:20px;">品质{{orderInfo.quality}}%</span>
					</div>
				</div>
			</div>
			<div class="f_row al_itm jc_sb" style="padding: 30px 0;font-family:SourceHanSansSC;">
				<div class="f_col al_itm" style="width:50%;">
					<span class="px24 color_4a">累计接单量</span>
					<span class="px24" style="padding:30px 0;">{{orderInfo.get}}</span>
				</div>
				<div class="f_col al_itm" style="width:50%;">
					<span class="px24 color_4a">进行中订单</span>
					<span class="px24" style="padding:30px 0;">{{orderInfo.conduct}}</span>
				</div>
			</div>
		</div>
		<!-- 积分明细 -->
		<div v-show="showClass==2">
			<table class="layui-table align_center" lay-skin="nob" id="score" lay-size="lg">
				<thead>
					<tr>
						<th class="align_center">途径</th>
						<th class="align_center">积分</th>
						<th class="align_center">时间</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,i) in datas" :key="i">
						<td>{{item.type}}</td>
						<td>{{item.money}}</td>
						<td>{{item.time}}</td>
					</tr>
				</tbody>
			</table>
			<div v-if='datas == [] || datas.length == 0 || !datas' style="width: 100%;line-height: 100px;text-align: center;color: #ccc;font-size: 18px;">暂无数据</div>
			<div style="padding: 5px 30px 0;" colspan="6" id="lypages"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'memberCenter',
		data() {
			return {
				showClass: 1,
				tables: '',
				online: false,
				userInfo: '',
				orderInfo: {
					total: 0,
					task: 0,
					month: 0,
					get: 0,
					conduct: 0,
					ontime: 0,
					quality: 0
				},
				datas: [],
				pages: 1,
				limit: 10,
				count: 1,
			}
		},
		created() {

		},
		mounted() {
			let _this = this;
			layui.use(['form', 'laypage', 'layer', 'table'], function() {
				var laypage = layui.laypage;
				var forms = layui.form;
				var table = layui.table;
				forms.render();				
				api.getMemberInfo({ //获取用户信息
					token: _this.getCookie('token')
				}).then((res) => {
					if(res.code == 1) {
						_this.userInfo = res.data;
						if(res.data.online_status == 1){
							$("#switch").attr('checked',true);
							forms.render();		
						}
					} else if(res.code == 0) {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				});
				api.getOrderCountInfo({ //获取订单完成信息
					token: _this.getCookie('token')
				}).then((res) => {
					if(res.code == 1) {
						_this.orderInfo = res.data;
					} else if(res.code == 0) {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				});
				api.getWagesLog({
					token: _this.getCookie('token'),
					page: _this.pages,
					limit: _this.limit
				}).then((res) => {
					console.log(res);
					if(res.code == 1) {
						_this.datas = res.data.list;
						_this.count = res.data.count;
						laypage.render({
							elem: 'lypages', //注意，这里的 lypages 是 ID，不用加 # 号
							theme: '#4876FF',
							count: _this.count,
							limit: 10,
							jump: function(obj, first) {
								if(!first) {
									_this.pages = obj.curr;
									_this.getScoreLogData();
								}
							}
						});
					}
				})
				forms.on('switch', function(e) {
					if(e.elem.checked){
						_this.changeStatus(1)
					}else{
						_this.changeStatus(0)
					}
				});
			});
		},
		methods: {
			getScoreLogData() {
				let _this = this;
				api.getInvoiceLog({
					token: _this.getCookie('token'),
					page: _this.pages,
					limit: _this.limit
				}).then((res) => {
					if(res.code == 1) {
						_this.datas = res.data.list;
					}
				})
			},
			setClass(e) {
				this.showClass = e;
			},
			changeStatus(num){
				let _this = this;
				api.changeOnLineStatus({
					token: _this.getCookie('token'),
					status: num
				}).then((res)=>{
					console.log(res)
					if(res.code == 1){
						_this.userInfo.online_status = num;
					}else if(res.code == 0){
						layer.msg(res.msg,{
							icon: 2,
							anim: 6
						})
					}
				})
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.memberCenter {
		font-family: SourceHanSansSC;
	}
	
	.currents {
		border-color: #4876FF;
		color: #4876FF;
	}
	
	.btns {
		color: #fff;
		font-size: 16px;
		width: 95px;
		height: 40px;
		border-radius: 4px;
		margin-left: 20px;
	}
	
	.dscBox {
		position: absolute;
		color: #fff;
		padding: 10px;
		box-sizing: border-box;
		background: rgba(0, 0, 0, 0.7);
		width: 442px;
		height: 531px;
		right: -465px;
		top: 0px;
		border-radius: 5px;
	}
	
	.editBtns {
		color: #ccc;
		font-size: 18px;
		font-weight: 100;
		border-color: #ccc;
		border: 1px solid;
		width: 40px;
		text-align: center;
		line-height: 20px;
	}
	
	.icons {
		margin-left: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/memberCenter.vue